import React from 'react';
import { useCustomerSearch } from '../../../hooks/useCustomerSearch';
import { SalesforceRef } from '../../../support/assessments';
import SalesforceLookupAutocomplete from './SalesforceLookupAutocomplete';

/** Answer input for a `sf_account` question — search a Salesforce Account by name or id. */
const SalesforceAccountLookupInput: React.FC<{
  value: SalesforceRef | null;
  onChange: (value: SalesforceRef | null) => void;
  disabled?: boolean;
}> = ({ value, onChange, disabled }) => {
  const { term, setTerm, results, isLoading } = useCustomerSearch();
  return (
    <SalesforceLookupAutocomplete
      label="Salesforce Account"
      placeholder="Search accounts by name or id"
      value={value}
      onChange={onChange}
      term={term}
      onTermChange={setTerm}
      options={results}
      loading={isLoading}
      disabled={disabled}
    />
  );
};

export default SalesforceAccountLookupInput;
